// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3P7hI","additionalInfo":"AgreementModal_additionalInfo__3TRVZ"};